import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import { useApiContext } from 'context/ApiContext';
import { KEYS } from 'helpers/react-query.config';
import { useGlobalContext } from 'context/GlobalContext';

interface Props {
  enabled?: boolean;
}

const useGetAllPartners = ({ enabled }: Props) => {
  const { showApiError, showApiAlert } = useGlobalContext();
  const { catalog: CatalogueApi } = useApiContext();
  const { t } = useTranslation('global');

  const { data, isLoading } = useQuery(
    [KEYS.catalog.partners.getAllPartners()],
    () => CatalogueApi.partner.getAllPartnersEnabled({ onlyEnabled: true }),
    {
      select: (response) => response?.data?.data,
      enabled,
      onError: (error: AxiosError) =>
        error?.response?.request?.status === 500
          ? showApiError(error, error?.message || t('errorMessages.partners'))
          : showApiAlert(
              error,
              error?.response?.data?.detail || t('errorMessages.partners')
            ),
      refetchOnWindowFocus: false
    }
  );

  return {
    allPartners: data,
    isAllPartnersLoading: isLoading
  };
};

export default useGetAllPartners;
